import { defineMessages } from 'react-intl';

export default defineMessages({
    loadingNextPageMessage: {
        id: 'quoteandbind.eu.Loading next page...',
        defaultMessage: 'Loading next page...'
    },
    policyType: {
        id: 'quoteandbind.eu.Underlying Policy.Policy Type',
        defaultMessage: 'Policy Type'
    },
    carrierName: {
        id: 'quoteandbind.eu.Underlying Policy.Insurer',
        defaultMessage: 'Insurer'
    },
    ULPolicyDetails: {
        id: 'quoteandbind.eu.Underlying Policy.UL Policy Details',
        defaultMessage: 'UL Policy Details'
    },
    policyNumber: {
        id: 'quoteandbind.eu.Underlying Policy.Policy Number',
        defaultMessage: 'Policy Number'
    },
    delete: {
        id: 'quoteandbind.eu.Underlying Policy.Delete',
        defaultMessage: 'Delete'
    },
    removeUnderlyingPolicy: {
        id: 'quoteandbind.eu.Underlying Policy.Remove?',
        defaultMessage: 'Remove Underlying Policy?'
    },
    removeEAVehicleExposure: {
        id: 'quoteandbind.eu.Underlying Policy.Remove EA Vehicle Exposure?',
        defaultMessage: 'Remove Vehicle Exposure?'
    },
    removeAdditionalPremise: {
        id: 'quoteandbind.eu.Underlying Policy.Remove Additional Premise',
        defaultMessage: 'Remove Additional Premise?'
    },
    removeAddress: {
        id: 'quoteandbind.eu.Underlying Policy.Remove Address',
        defaultMessage: 'Remove Address?'
    },
    confirmDelete: {
        id: 'quoteandbind.eu.Underlying Policy.Confirm Delete',
        defaultMessage: 'Please Confirm Delete.'
    },
    cancel: {
        id: 'quoteandbind.eu.Underlying Policy.Cancel',
        defaultMessage: 'Cancel'
    },
    allUnderlyingPolicisAdded: {
        id: 'quoteandbind.eu.Underlying Policy.All Underlying Policies Added',
        defaultMessage: 'All Underlying Policies Added'
    },
    refreshUnderlyingPolicyInfo: {
        id: 'quoteandbind.eu.quick.views.REFRESH UNDERLYING POLICY INFO',
        defaultMessage: 'REFRESH UNDERLYING POLICY INFO'
    },
    addULpoliciesButtonLabel: {
        id: 'quoteandbind.eu.quick.views.ADD UNDERLYING POLICY/EXPOSURE',
        defaultMessage: 'ADD UNDERLYING POLICY/EXPOSURE'
    },
    ulPoliciesRefreshMessage: {
        id: 'quoteandbind.eu.Refreshing Underlying Policies...',
        defaultMessage: 'Refreshing Underlying Policies...'
    }
});
